<main id="onboard" class="onboard auto-height" *ngIf="hideLandingBanner">
    <section>
        <div class="row-wrapper landing-banner-wrap">
            <div id="top-home-banner">
                <div class="topBanner adaptiveimage image parbase">
                    <section class="top-home-banner auto-height full-width">
                        <ul class="row-wrapper" style="max-width: 100%;">
                            <li class="col medium-12 small-12 large-12" style="padding: 0;">
                                <div class="large-banner">
                                    <div class="inner bg-center banner-container bg-medium-blue" style="background-size: cover; background-position: center center; background-image: url(https://www.flysas.com/content/dam/sas/images/wifi-portal/wifi_onboard_clouds.jpg.transform/hero-large/img.jpg);">
                                        <div class="banner-wrapper " title="SAS WiFi">
                                            <div>
                                                <div class="banner-inner-top-content">
                                                    <div>
                                                    </div>
                                                </div>
                                                <div class="banner-inner-middle-content">
                                                    <div>
                                                        <div class="text parbase">
                                                            <div class="wifi-logo-center">
                                                            <p><img alt="wifi" width="56"
                                                                    src="https://www.flysas.com/v2/de-design-library/assets/icons/raw/cl--wifi?color=009" />
                                                            </p>
                                                        </div>
                                                            <h3 style="text-align: center;"><span class="wifi-heading text-sas-blue">SAS
                                                                    WiFi</span></h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </section>
                </div>
            </div>
            <div class="center landing-connected" *ngIf="!showLandingBanner">
                <svg class="check-wifi-icon" role="presentation" tabindex="-1">
                    <use xlink:href="#cl--check" href="#cl--check" tabindex="-1"></use>
                </svg>
                <h3 tabindex="-1">{{'youAreConnected' | translate}}</h3>
            </div>

            <div class="hr">

            </div>
        </div>

        <div class="connected-success" *ngIf="!showLandingBanner">
            <button id="buyConnected" (click)="openPaymentSelectionPage();" class="btn medium primary buy-wifi-home"
                role="button" *ngIf="!voucherConnectActivate">{{'buymoredevice' | translate}}</button>

            <div class="center wifi-info-wrapper-landing">
                <a href="javascript:void(0)" class="wifi-access-link" id="wifiAccess" tabindex="0"
                    (click)="readmoreContent()">WiFi access & prices</a>
                <button class="wifi-access-info-icon-landing" type="button" id="infoIconButton" tabindex="-1"
                    (click)="readmoreContent()">
                    <svg class="info-wifi-icon-landing" role="presentation" tabindex="-1">
                        <use xlink:href="#cl--info-circle" href="#cl--info-circle" tabindex="-1"></use>
                    </svg>
                </button>
            </div>
        </div>

        <div [ngClass]="{'connect-content-banner':!isCharter, 'connect-content-banner-charter': isCharter}"
            *ngIf="showLandingBanner">
            <div class="large-4 small-6"
                [ngClass]="{'col-landing medium-5 pad-l-25 class-tier': !isCharter, 'charter-col large-3': isCharter}">
                <div *ngIf="!isCharter">
                    <div class="row-wrapper free-wifi-info">
                        <p>
                            <span *ngIf="showLongHaulText">SAS Business, EuroBonus</span>
                            <span *ngIf="!showLongHaulText">EuroBonus</span>
                            <br> Diamond and Gold
                        </p>
                    </div>
                    <div class="row-wrapper  free-wifi-info">
                        <p class="mr-btm-0">
                            <span>SAS Plus and Go,</span>
                        </p>
                        <p>
                            EuroBonus Silver and Member
                        </p>

                    </div>
                </div>
                <div *ngIf="isCharter">
                    <div class="free-wifi-info-charter">
                        <p>
                            <span>Charter traveler</span>
                            <br>on SAS flights
                        </p>
                    </div>

                </div>

            </div>
            <div class="medium-3 small-6 mobile-access"
                [ngClass]="{'col-landing large-4':!isCharter, 'charter-col large-3': isCharter}">
                <div *ngIf="!isCharter">
                    <div class="row-wrapper pad-l-15 buy-wifi-information">
                        <p>
                            <span class="free-text">FREE ACCESS</span>
                            <br> for 1 device
                        </p>
                    </div>
                    <div class="row-wrapper pad-l-15 buy-wifi-information pt-35">
                        <p>
                            <span class="free-text">BUY ACCESS</span>
                            <br> per device
                        </p>
                    </div>
                </div>
                <div *ngIf="isCharter">
                    <div class="buy-wifi-information-charter">
                        <p>
                            <span class="free-text">BUY ACCESS</span>
                            <br> per device
                        </p>
                    </div>

                </div>
            </div>
            <div class="small-12 connect-mobile wifi-info-button-container"
                [ngClass]="{'col-landing medium-4 large-4':!isCharter, 'medium-6 large-6 charter-col': isCharter}">
                <span class="mobile-hidden" [ngClass]="{'line':!isCharter, 'line-charter': isCharter}"></span>
                <div [ngClass]="{'connect-landing-btn-charter': isCharter, 'center connect-landing-button': !isCharter}">
                    <button class="btn medium primary connect-wifi landing-connect"
                        [ngClass]="{'landing-connect-charter': isCharter}" id="landing-connect"
                        (keydown.shift.tab)="evntDetect($event, '#freeInternetConnectivity')"
                        (keydown.Enter)="connectToWifi();" (click)="connectToWifi()"
                        [ngClass]="{'disabled': connectButtonDisabled||!showLandingBanner}"
                        [disabled]="connectButtonDisabled" tabindex="0" role="button">
                        {{'connectWiFi' | translate}}
                    </button>
                    <div class="voucher-connect-link">
                        <a class="voucher-link" href="javascript:void(0)" (click)="openVoucherConnectPage();"
                            *ngIf="showVoucherLink">Do you have a Voucher code?</a>
                        <!-- <a class="voucher-link" href="javascript:void(0)" (click)="openVoucherConnectPage();">Do you have a Voucher code?</a> -->
                    </div>

                    <div class="voucher-connect-link-charter">
                        <a class="voucher-link-charter" href="javascript:void(0)" *ngIf="showVoucherCharter" (click)="openVoucherConnectPage();">Do
                            you have a Voucher code?</a>
                    </div>
                </div>
            </div>

            <div class="prices-content-box">
                <div class="large-12">
                    <span *ngFor="let showPriceList of formatPrices; let last = last">
                        {{ showPriceList[1] }} {{ showPriceList[0] }}                    <ng-container *ngIf="!last">/</ng-container>
                    </span>
                </div>
            </div>
        </div>

        <!-- <div class="grabit-content-banner" *ngIf="showLandingBanner && isGrabitEnable">
            <div class="large-4 small-12 col-grabit medium-5 pad-l-25">
                <div class="row-wrapper grabit-wifi-info">
                    <p>
                        <span>TEST SAS WIFI FOR FREE</span>
                    </p>
                </div>
            </div>
            <div class="medium-3 small-12 mobile-access col-grabit large-4'">
                <div class="row-wrapper pad-l-50 grabit-wifi-information">
                    <p>
                        <span>by watching an advertisement</span>
                    </p>
                </div>
            </div>
            <div class="small-12 connect-mobile wifi-info-button-container col-grabit medium-4 large-4">
                <span class="mobile-hidden line"></span>
                <div class="center connect-grabit-button">
                    <a href="{{grabitUrl}}" class="btn primary connect-wifi landing-connect" role="button"
                        target="_blank" rel="noopener">
                        {{'goTo.grabIt' | translate}}
                    </a>
                </div>
            </div>
        </div>
         -->
        <div class="clear"></div>
        <div id="activateScreen" class="activateScreen" *ngIf="showActivateScreen">
            <app-travelers></app-travelers>
        </div>
        <div id="paymentSelectionScreen" class="paymentSelectionScreen" *ngIf="showPaymentSelectionScreen">
            <app-paymentSelection></app-paymentSelection>
        </div>
        <div id="voucherLoginScreen" class="voucherLoginScreen" *ngIf="showVoucherLogin">
            <app-voucherSelector></app-voucherSelector>
        </div>
        <div id="switchScreen" class="switchScreen" *ngIf="showSwitchScreen">
            <app-switch></app-switch>
        </div>
        <div class="show-flight">
            {{showFlightNumber}}
        </div>
        <div class="onboardFeatures">
            <h3 class="center browse-free mrgn-b-20" *ngIf="showLandingBanner">Browse our free sites</h3>
            <h3 class="center browse-free connectedContent mrgn-b-20" *ngIf="!showLandingBanner">YOU may ALSO LIKE</h3> 
            <app-features></app-features>
        </div>
    </section>
    <section class="modal wifi-onboard-landing-terms" id="wifi-onboard-landing-terms"
        data-modal="wifi-onboard-landing-terms" style="display: none;" [ngClass]="{'show-element': showLandingTerms}">
        <div class="modal-dialog medium">
            <div class="modal-tnc-content">
                <div class="modal-header">
                    <button type="button" class="modal-close" data-modal-close="wifi-onboard-landing-terms"
                        (keydown)="keyshiftTabFocus($event, '#tnc-connect');"
                        (keydown.enter)="closeLandingTermsOverlay()" (click)="closeLandingTermsOverlay()" tabindex="0"
                        id="close-switch" [attr.aria-label]="('close' | translate)">×</button>
                    <h4 class="modal-title" id="tnc-header">{{'wifiTnc.loggedInCustomer' | translate}}</h4>
                    <p [innerHtml]="'wifiTnc.instruction' | translate"> </p>
                </div>
                <fieldset class="wifi-checkboxs">
                    <legend class="hideElement"> </legend>
                    <div class="checkbox-wrap large-12 medium-12 small-12 margin-auto sasTEC">
                        <input type="checkbox" id="sasTnCEb" name="sastandc" value="false" [checked]="sasTnCChecked"
                            (change)="sasTnCChecked = !sasTnCChecked; checkLandingTermsBtn();" tabindex="0"
                            [attr.aria-label]="('wifiLogin.label.sasTnC' | translate) +' '+ ('wifiLogin.sasTnC' | translate)" />
                        <label for="sasTnCEb">
                            <span class="icon-ok" id="sasTcEbCheck"> </span>
                            <div class="label-content">{{'wifiLogin.label.sasTnC' | translate}}
                                <a href="javascript:void(0)" id="sasLinkAccess"
                                    (click)="openSasTnC()">{{'wifiLogin.sasTnC' | translate}}</a>
                            </div>
                        </label>
                        <div class="tool-tip bottom-left small error onboard-tool-tip"
                            *ngIf="showSastandcondErrorMsg && !enableLandingTermsBtn" role="alert">
                            <div class="tool-tip-inner">
                                <div>{{'wifiLogin.loggedInCustomer' | translate}}</div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <div class="modal-tnc-body">
                    <div class="tnc-content-wrapper">
                        <div class="wrap-button tnc-connect-container">
                            <button class="btn primary small small-12 tnc-connect" id="tnc-connect"
                                (click)="connectToWifiFromTerms()" tabindex="0"
                                (keydown.Tab)="keytabFocus($event, '#close-switch');">{{'tnc.continue' |
                                translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="buy-wifi-email text-white" *ngIf="readmoreOverLay">
        <div class="modal fade in readmore-content" id="myModal" role="dialog" style="display: block">
            <div class="wrapper">
                <div class="modal-body">
                    <div class="header-div">
                        <button type="button" class="modal-close" id="update-modal-close" (click)="closeOverlay()"
                            tabindex="0" [attr.aria-label]="('close' | translate)" (keyup.enter)="closeOverlay()">×
                        </button>

                    </div>
                    <div>
                    <app-wifiaccess-prices></app-wifiaccess-prices>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="sasTncUser">
        <div class="row-block">
            <div class="modal fade" id="myModal" [ngClass]="{'in': showSasTnC}" *ngIf="showSasTnC"
                style="display: block !important">
                <div class="wrapper">
                    <div class="modal-body">
                        <header>
                            <h3 id="model-header"></h3>
                            <button type="button" class="modal-close" (click)="closeSasTnC()" id="termsAndConClose"
                                tabindex="0" [attr.aria-label]="('close' | translate)"
                                (keydown.tab)="termsAndConditionEvents($event, '#sasLandAcc')"
                                (keydown.shift.tab)="termsAndConditionEvents($event, '#sasLandAcc')">× </button>
                        </header>
                        <div [innerHtml]="sasTnC" class="modal-content terms-condition" tabindex="0" id="sasLandAcc"
                            (keydown.tab)="termsAndConditionEvents($event, '#termsAndConClose')"
                            (keydown.shift.tab)="termsAndConditionEvents($event, '#termsAndConClose')"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>

<div *ngIf="hideLandingBanner" class="chat-bot" style="display:none;">
    <a (click)="connectToChat()" tabindex="0" role="button">
        <span class="bold">{{'chatSupport.mainText' | translate}}
            <span class="icon-external-link-white" role="presentation"></span>
        </span>
        <span class="font-12">{{'chatSupport.subText' | translate}}</span>
        <span class="icon-bot-chat"></span>
    </a>
</div>